import { render, staticRenderFns } from "./ActionConfirmModal.vue?vue&type=template&id=6b52a08c&scoped=true&"
import script from "./ActionConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ActionConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52a08c",
  null
  
)

export default component.exports